import React from 'react';
// Images
import EyesImage from '../../assets/images/logos/lady-cender-dominatrix-goddess-logo3.webp';
// Constants
import { CompanyName, CompanyTagLine, LocationCity } from '../../utils/Constants';
import { Link } from 'react-router-dom';
import { ABOUT_PAGE_URL, CONTACT_PAGE_URL, GALLERY_PAGE_URL } from '../../utils/Routes';

function HomePageHeader() {
  return (
    <header
      id='hero'
      role='banner'
      aria-labelledby='hero-title'
      className='relative grid w-full min-h-screen overflow-hidden'
    >
      {/* Decorative cutout (under text) */}
      <section
        className='absolute grid h-full w-full pointer-events-none'
        aria-hidden='true'
      >
        <div className='relative grid h-full'>
          <div className='absolute inset-0 blur-3xl opacity-40 bg-[radial-gradient(closest-side,theme(colors.colour6)_0%,transparent_70%)]' />
          <img
            src={EyesImage}
            alt=''
            className='mx-auto my-auto h-full max-h-[65vh] md:max-h-[75vh] w-auto object-contain drop-shadow-[0_0_32px_rgba(255,0,200,0.35)]'
            loading='eager'
            decoding='async'
            fetchpriority='high'
          />
        </div>
      </section>

      {/* TEXT / CTAs — above cutout */}
      <div className='relative items-center z-20 grid h-full place-items-center text-center px-8'>
        {/* Tagline */}
        <article className='grid grid-rows-reg h-full max-h-[70vh] lg:max-h-[90vh]'>
          <div className='pt-12'>
            <div
              className='grid grid-flow-col items-center justify-center gap-x-2'
              aria-label='Availability'
            >
              <span className='glowing-dot' aria-hidden='true' />
              <h2 className='neon_text_thin_redpink text-xl sm:text-2xl md:text-3xl font-fancyFont tracking-widest'>
                Available now for sessions
              </h2>
            </div>

            <div className='grid items-center'>
              <h1
                id='hero-title'
                className='text-colour1 grid lg:grid-flow-col lg:w-fit lg:justify-center lg:gap-x-2 lg:mx-auto text-xl font-titleFont tracking-wide leading-tight drop-shadow-[0_0_18px_var(--colour6)]'
                itemProp='name'
              >
                Based in Los Angeles, touring nationally, and Fly Me To You
                (FMTY) available.
              </h1>
            </div>
          </div>

          <section className='grid items-end gap-y-8'>
            <div className='grid h-fit gap-y-4'>
              <div>
                {/* <p className='text-xl lg:text-2xl font-serif italic drop-shadow-[0_0_18px_var(--colour6)]'>
                  “I am a deity. Not just a goddess — an actual goddess.”
                </p> */}
                <p className='font-titleFont text-xl'>{CompanyTagLine}</p>
              </div>

              <div className='grid' role='group' aria-label='Primary actions'>
                <div className='grid grid-cols-2 gap-4'>
                  {/* Primary — Blackletter Bar */}
                  <div className='grid'>
                    <Link
                      to={CONTACT_PAGE_URL}
                      aria-label='Book a session with Lady Cinder'
                      className='grid place-items-center px-8 py-2 text-base uppercase tracking-widest font-titleFont bg-colour3 text-colour1 border border-colour1/20 rounded-md hover:border-colour5 hover:shadow-[0_0_22px] hover:shadow-colour5 focus:outline-none focus:ring-2 focus:ring-colour5'
                    >
                      Book Now
                    </Link>
                  </div>

                  {/* Secondary — Neon Sign (filled) */}
                  <div className='grid'>
                    <Link
                      to={ABOUT_PAGE_URL}
                      aria-label='Learn about Lady Cinder'
                      className='grid place-items-center px-8 py-2 text-base uppercase tracking-widest font-titleFont bg-colour6 text-colour1 rounded-md hover:shadow-[0_0_22px] shadow-colour6 hover:bg-colour8 hover:shadow-colour8 focus:outline-none focus:ring-2 focus:ring-colour8'
                    >
                      See More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </article>
      </div>

      {/* Corner labels are decorative; expose content to AT via sr-only above */}
      <div
        className='absolute bottom-10 left-10 font-titleFont text-xl lg:text-5xl tracking-widest font-semibold z-30'
        aria-hidden='true'
      >
        {LocationCity}
      </div>
      <div
        className='absolute bottom-10 right-10 font-titleFont text-xl lg:text-5xl tracking-widest font-semibold z-30'
        aria-hidden='true'
      >
        {CompanyName}
      </div>
      {/* Invisible, SEO/AT-friendly context */}
      <div className='sr-only' itemScope itemType='https://schema.org/Person'>
        <span itemProp='name'>Lady Cinder</span>
        <span
          itemProp='address'
          itemScope
          itemType='https://schema.org/PostalAddress'
        >
          <span itemProp='addressLocality'>{LocationCity}</span>
        </span>
        <span itemProp='jobTitle'>Dominatrix & Hypnosis Specialist</span>
      </div>
    </header>
  );
}

export default HomePageHeader;
